<template>
  <div>
    <v-app
      :style="{'background-image': 'url(' + require('../assets/BG-image.jpg') + ')'}"
      style="background-size: cover;"
    >
      <v-card elevation="0">
        <v-toolbar class="secondary" dark>
          <v-toolbar-title>
            <span class="font-weight-bold display-1 white--text">AdjusterMate</span>
          </v-toolbar-title>
        </v-toolbar>
      </v-card>
      <v-row>
        <v-col cols="12" sm="8"></v-col>
        <v-col cols="12" sm="4">
          <v-card
            class="grey lighten-3 mt-5 mr-5"
            elevation="0"
            style="height:auto;background-size: cover;"
          >
            <v-card-text>
              <div class="layout column align-center">
                <a href>
                  <img src="@/assets/logo.png" width="150" height="140" />
                </a>
                <strong
                  class="--text h7 justify-center font-weight-black"
                  style="font-size:25px"
                >Login</strong>
              </div>
            </v-card-text>
            <v-form v-if="state == 0" ref="form" v-model="valid1" lazy-validation>
              <v-container>
                <v-row>
                  <v-col>
                    <v-card-text>
                      <v-text-field
                        single-line
                        :rules="[rules.required, rules.counter, rules.email]"
                        label="Email"
                        v-model="userName"
                        append-icon="email"
                      ></v-text-field>
                      <v-text-field
                        label="Password"
                        :rules="[rules.required, rules.min]"
                        :type="isPwd ? 'text' : 'password'"
                        name="input-10-1"
                        hint="At least 8 characters"
                        @click:append="isPwd = !isPwd"
                        single-line
                        v-model="password"
                        :append-icon="isPwd ? 'mdi-eye' : 'mdi-eye-off'"
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        text
                        id="submit"
                        block
                        large
                        class="secondary"
                        :loading="loading"
                        @click="LoginToApp()"
                      >Submit</v-btn>
                    </v-card-actions>
                    <v-card-text>
                      <a>
                        <u text class="grey lighten-3" @click="ForgotPassword()">Forgot password ?</u>
                      </a>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-form class="pa-4 pt-6" v-if="state == 1">
              <v-container>
                <v-row>
                  <v-col>
                    <v-card-text>
                      <v-text-field
                        :append-icon="isPwd2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="isPwd2 ? 'text' : 'password'"
                        name="input-10-1"
                        hint="At least 8 characters"
                        @click:append="isPwd2 = !isPwd2"
                        single-line
                        v-model="newPassword"
                        label="New Password"
                      ></v-text-field>
                      <v-text-field
                        :append-icon="isPwd3 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="isPwd3 ? 'text' : 'password'"
                        name="input-10-1"
                        hint="At least 8 characters"
                        @click:append="isPwd3 = !isPwd3"
                        v-model="confirmPassword"
                        label="Confirm Password"
                      ></v-text-field>
                    </v-card-text>

                    <v-spacer></v-spacer>

                    <v-btn
                      block
                      class="white--text mt-4 secondary"
                      @click="confirmPwd()"
                      color="#f36a58"
                    >Confirm</v-btn>
                    <v-btn block class="white--text mt-4" @click="state = 0" color="#9E9E9E">Back</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card>
          <v-snackbar
            v-model="alertPositive"
            color="secondary"
            :timeout="timeout"
            bottom="bottom"
          >{{ text }}</v-snackbar>
          <v-snackbar
            v-model="alertNegetive"
            color="primary"
            :timeout="timeout"
            bottom="bottom"
          >{{ text }}</v-snackbar>
        </v-col>
      </v-row>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import { Auth } from "aws-amplify";

export default {
  name: "HelloWorld",
  components: {},
  data() {
    return {
      valid1: true,
      alertNegetive: false,
      timeout: 1700,
      alertPositive: false,
      text: "",
      textalert: "Login Successfully",
      user: "",
      state: 0,
      isPwd3: false,
      isPwd2: false,
      isPwd: false,
      userName: "",
      password: "",
      ex4: "",
      loading: false,
      rules: {
        required: value => !!value || "Required.",
        min: value => value.length >= 6 || "Min 8 characters",
        counter: value => value.length <= 30 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  created() {
    this.getforgetStatus();
  },
  methods: {
    getforgetStatus() {
      if (this.$store.getters.get_forPasswordStatus == 1) {
        this.alertPositive = true;
        this.text = "Successfully changed password";
      }
    },
    ForgotPassword() {
      this.$router.push("/ForgotPassword");
    },
    async confirmPwd() {
      this.confirmLoading = true;
      if (this.confirmPassword === this.newPassword) {
        try {
          const result = await Auth.completeNewPassword(
            this.user,
            this.newPassword
          )
            .then(user => {
              // at this time the user is logged in if no MFA required
              return user;
            })
            .catch(e => {
              return e;
            });
          ////console.log(result);
          //   alert(JSON.stringify(result));
          if (result.username) {
            this.state = 0;
            this.alertPositive = true;
            this.text = "Password Reset Successful";
          } else {
            this.alertNegetive = true;
            this.text = result.message;
          }
        } catch (err) {
          ////console.log(err);
          this.alertNegetive = true;
          this.text = err.message;
        }
      } else {
        this.alertNegetive = true;
        this.text = "Password did not match";
      }
    },
    async getAllOrgDetails(username) {
      var input = {
        api_key: "kARYYNG1An",
        api_password: "068u4hKm79",
        command: "Login_getAllOrgDetails",
        input: {
          emaild: username
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        var allInforOrg = res.data.data.data;

        if (res.data.data.success == true) {
          this.loading = false;
          this.text = "Login Success";
          this.$store.commit("SET_loginStatus", this.text);
          this.$store.commit("SET_OrgDetails", allInforOrg[0]);
          this.$router.push("/main/ManageSurveys/ManageSurveys");
          this.cleardata();
        } else {
          this.loading = false;
          this.alertNegetive = true;
          this.text = "Incorrect Username or Password";
          this.cleardata();
        }
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    cleardata() {
      this.$refs.form.reset();
    },
    async LoginToApp() {
      this.loading = true;
      try {
        const user = await Auth.signIn(this.userName, this.password);
        this.user = user;
        // console.log(user);
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          this.loading = false;
          this.state = 1;
          this.password = "";
        } else {
          this.getAllOrgDetails(this.userName);
        }
      } catch (err) {
        this.loading = false;
        if (err.code === "UserNotConfirmedException") {
          this.alertNegetive = true;
          this.text = "Sign up steps were not complete";
        } else if (this.userName == "") {
          this.alertNegetive = true;
          this.text = "Email Required";
        } else if (this.password == "") {
          this.alertNegetive = true;
          this.text = "Password Required";
        } else if (err.code === "PasswordResetRequiredException") {
          this.alertNegetive = true;
          this.text = "Password Needs To Be Reset";
        } else if (err.code === "ResourceNotFoundException") {
          this.alertNegetive = true;
          this.text = "User Not Found";
        } else if (err.code === "NotAuthorizedException") {
          this.alertNegetive = true;
          this.text = "Incorrect Username Or Password";
        } else {
          this.alertNegetive = true;
          this.text = "User Not Found";
        }
        this.cleardata();
      }
    }
  }
};
</script>


